import { noop } from '@kofno/piper';
import { Cancel, Task } from 'taskarian';
import { editTemplatesCheck, readyPublishStore } from '.';
import LearningCollectionEditStore from '..';
import { callApi } from '../../../../../../Appy';
import { currentUserStore } from '../../../../../../CurrentUserStore';
import { Error } from '../../../../../../ErrorHandling';
import { findLinkT } from '../../../../../../LinkyLinky';
import { Link } from '../../../../../../Resource/Types';
import { learningCollectionEditFormResourceDecoder } from '../../../Decoders';
import { LearningCollectionError } from '../../../Types';
import { LearningCollectionEditFormResource, Loading } from '../Types';

const processTemplateLink =
  (learningCollectionId: string) =>
  (link: Link): Task<LearningCollectionError, Link> =>
    Task.succeed<LearningCollectionError, string>(learningCollectionId).map((v) => ({
      ...link,
      href: link.href.replace('{learning_collection_id}', `${v}`),
    }));

const editLink =
  (learningCollectionId: string) =>
  (links: ReadonlyArray<Link>): Task<LearningCollectionError, Link> =>
    Task.succeed<LearningCollectionError, ReadonlyArray<Link>>(links)
      .andThen(findLinkT('edit-learning-collection-template'))
      .andThen(processTemplateLink(learningCollectionId));

const loadEditLearningCollection = (
  state: Loading,
): Task<LearningCollectionError, LearningCollectionEditFormResource> =>
  Task.succeed<LearningCollectionError, ReadonlyArray<Link>>(currentUserStore.links)
    .andThen(editLink(state.id))
    .andThen(callApi(learningCollectionEditFormResourceDecoder, {}));

export const checkTemplateAndReadyStoreForEdits =
  (store: LearningCollectionEditStore) =>
  (resource: LearningCollectionEditFormResource): Task<Error, void> =>
    editTemplatesCheck(resource)
      .map(({ template, publishTemplate }) => {
        readyPublishStore(store, resource, publishTemplate);
        store.learningDesignsStore.loading(resource.payload.productLicense);
        store.ready(resource, template);
      })
      .orElse(() => Task.succeed(store.templateLoadError()));

const loadForEdits = (state: Loading, store: LearningCollectionEditStore): Cancel =>
  loadEditLearningCollection(state)
    .andThen(checkTemplateAndReadyStoreForEdits(store))
    .fork(store.loadError, noop);

export default loadForEdits;
